"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vesselInfo: {
    title: 'Vessel Information',
    vesselCode: 'Vessel Code',
    vesselName: 'Vessel Name',
    callSign: 'Call Sign',
    result: 'Vessel Information  Search Result',
    vesselNationality: 'Nationality',
    imoCode: 'IMO Code',
    classfication: 'Classfication',
    grossTon: 'Gross Ton',
    netTon: 'Net Ton',
    dwt: 'DWT',
    totalTeu: 'Total Teu',
    buildDate: 'Build Date',
    validateNul: 'Please enter search conditions'
  },
  button: {
    search: 'Search'
  }
};